import { gql } from '@apollo/client';

export const GET_TRENDING_FOLLOWING = gql`
  query getTrendingFollowing($limit: Int) {
    trendingStories(scope: FOLLOWING, limit: $limit) {
      topic
      label
      storyCount
      topStoryId
    }
  }
`;
